<template>
  <div>
    <activity-component
      :activity="activity"
      :description="description"
    />
  </div>
</template>

<script>
import { getUserData } from '@/auth/utils';
import ActivityComponent from './ActivityComponent.vue';

export default {
  components: {
    ActivityComponent,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      self: getUserData(),
    }
  },
  computed: {
    description() {
      const { user, labels } = this.activity;
      const creator = user.uuid === this.self.uuid ? this.$t('You') : user.name;

      return `${creator} detached ${labels.length > 1 ? 'labels' : 'label'} ${labels.map(label => `<span style="padding: 2px 6px; border-radius: 4px; color: white; background-color:${label.color}; white-space: nowrap">${label.name}</span>`).join(' ')} from this task.`;
    },
  },
}
</script>
